(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    var buyBtn = form.querySelector('[name="add"]');
    if (!buyBtn) return;

    var bar = document.createElement('div');
    bar.className = 'mys-sticky-cart';
    bar.innerHTML =
      '<div class="mys-sticky-cart__inner">' +
        '<div class="mys-sticky-cart__info">' +
          '<span class="mys-sticky-cart__title" id="mysStickyTitle"></span>' +
          '<span class="mys-sticky-cart__price" id="mysStickyPrice"></span>' +
        '</div>' +
        '<button type="button" class="button mys-sticky-cart__btn" id="mysStickyBtn">Añadir al carrito</button>' +
      '</div>';
    document.body.appendChild(bar);

    var titleEl = document.querySelector('.product__title');
    var priceEl = document.querySelector('.price-item--regular, .price-item--sale');
    if (titleEl) bar.querySelector('#mysStickyTitle').textContent = titleEl.textContent.trim();
    if (priceEl) bar.querySelector('#mysStickyPrice').textContent = priceEl.textContent.trim();

    bar.querySelector('#mysStickyBtn').addEventListener('click', function () {
      if (!buyBtn.disabled) buyBtn.click();
    });

    // Sync disabled state
    var mo = new MutationObserver(function () {
      bar.querySelector('#mysStickyBtn').disabled = buyBtn.disabled;
    });
    mo.observe(buyBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Show when buy button scrolls out of view
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });

    observer.observe(buyBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
